// /components/DietAssessment/components/AssessmentNavigation.js

import React, { useContext } from 'react';
import { Box } from '@mui/material';
import { AssessmentContext } from '../../../lib/contexts';
import { AssessmentBackButton } from './AssessmentBackButton';
import { AssessmentNextStepButton } from './AssessmentNextStepButton';
import { AssessmentSkipButton } from './AssessmentSkipButton';

export const AssessmentNavigation = ({ onBack, onNext, nextAllowed, backAllowed, disabled }) => {
  const { state } = useContext(AssessmentContext);
  const { currentStepInfo } = state;

  // Use props if provided, otherwise fall back to context
  const showBackButton = typeof backAllowed === 'boolean' ? backAllowed : state.backAllowed;
  const showSkipButton = currentStepInfo?.is_optional;
  const showAssessmentNextButton = typeof nextAllowed === 'boolean' ? nextAllowed : state.nextAllowed;

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', width: '100%', gap: '16px' }}>
        {showBackButton && <AssessmentBackButton onClick={onBack} />}
        {showAssessmentNextButton && (
          <AssessmentNextStepButton
            onClick={onNext}
            disabled={disabled}
            boxSx={{ width: '140px', maxWidth: '140px' }}
          />
        )}
      </Box>
      {showSkipButton && <AssessmentSkipButton />}
    </>
  );
};
